<template>
    <CustomTopSheetDialog v-model="show" :width="600" :title="null" :customclass="'px-4 pt-4'">
        <template #title>
            <h3 class="text-left dialog-title" color="primary">
                {{ $t('shop.profile.brandsDialog.title') }}
            </h3>
        </template>

        <template #default>
            <p v-html="$t('shop.profile.brandsDialog.description')">
            </p>
            <v-divider></v-divider>
            <v-row justify="center" class="">
                <!-- <v-col cols="12" md="6" class="list-column px-2">
                    <v-list>
                        <v-list-item v-for="item in selectedItems" :key="item.id" variant="outlined">
                            {{ item.name }}

                            <template v-slot:prepend>
                                <v-btn variant="flat" size='x-small' color="error" fab icon="mdi-minus" class="mr-3"
                                    @click="() => removeBrand(item.id)">
                                </v-btn>
                            </template>
</v-list-item>
</v-list>
</v-col> -->
                <v-col class="px-2" cols="12" md="12">
                    <v-autocomplete v-model="selectedItems" @update:search="onSearch" variant="outlined"
                        density="comfortable" :hide-details="true" @update:model-value="onSelectItem" :items="filteredItems" item-title="name" return-object
                         v-bind:menu="menu" :placeholder="$t('shop.profile.brandsDialog.placeholder')" chips closable-chips multiple hide-no-data clear-on-select>
                    </v-autocomplete>
                </v-col>
            </v-row>
        </template>

        <template #actions>
            <v-container class="d-flex align-items-center justify-content-end">
                <v-btn class="px-3 py-1 mr-3" variant="flat" rounded="xl" size="large" prepend-icon="mdi-cancel"
                    color="default" @click="closeSheet">{{ $t('entity.action.cancel') }}</v-btn>
                <v-btn class="px-3 py-1" variant="flat" rounded="xl" size="large" prepend-icon="mdi-content-save"
                    color="primary">{{ $t('entity.action.save') }}</v-btn>
            </v-container>
        </template>
    </CustomTopSheetDialog>
</template>


<script>
import { inject } from 'vue'
export default {
    name: "EditShopBrandsDialog",
    methods: {

    },
};


</script>
<script setup>
import { ref, watch, computed, defineProps, defineEmits, getCurrentInstance } from 'vue';
import CustomTopSheetDialog from '@/components/custom/CustomTopSheetDialog.vue';


const productCategories = inject('productCategories', []);
const originalShop = inject('shop');
// const  = ref(Object.assign({}, orignalShop.value));
const shop = ref({ ...originalShop.value });
const { proxy } = getCurrentInstance();
const filteredItems = ref([]);
const loading = ref(false);
const selectedItems = ref([]);
const selectedItem = ref(null);
const menu = ref(false);
const fetchOwnShop = inject('fetchOwnShop');
// firstProductCategory.value = Object.values(shop.value.productCategories);

watch(() => originalShop.value, (newShop) => {
    if (!newShop) return;
    shop.value = { ...newShop }; // Create a fresh copy when the original shop changes
    selectedItems.value = shop.value.brands
}, { deep: true, immediate: true });

const props = defineProps({
    modelValue: {
        type: Boolean,
        required: true,
    },

});


// fetch : /api/shop/brand/query?keyword=ka

const onSearch = async (searchTerm) => {
    if (!searchTerm || searchTerm.length < 2) {
        filteredItems.value = []; // Clear the items when input is empty
        return;
    }

    loading.value = true;
    const hardToken = localStorage.getItem("hardToken");
    const username = localStorage.getItem("username");
    const softToken = localStorage.getItem("softToken");
    try {
        const response = await proxy.$axios.get("/shop/brand/query", {
            headers: {
                'X-Auth-HARDTOKEN': hardToken,
                'X-Auth-SOFTTOKEN': softToken,
                'X-Auth-USER': username
            },
            params: { keyword: searchTerm },
        });

        // Update filteredItems with the API response
        filteredItems.value = response.data.data || [];
    } catch (error) {
        console.error("Error fetching search results:", error);
        filteredItems.value = [];
    } finally {
        loading.value = false;
    }
};

const onSelectItem = async (itemId) => {
    selectedItem.value = null;
    // Find selected item
    const item = filteredItems.value.find(i => i.id === itemId);

    const itemAlreadySelected = selectedItems.value.some(i => i.id === itemId);
    const hardToken = localStorage.getItem("hardToken");
    const username = localStorage.getItem("username");
    const softToken = localStorage.getItem("softToken");
    if (item && !itemAlreadySelected) {

        try {

            const response = await proxy.$axios.put(`/shop/brand/${itemId}`, {}, {
                headers: {
                    'X-Auth-HARDTOKEN': hardToken,
                    'X-Auth-SOFTTOKEN': softToken,
                    'X-Auth-USER': username
                }
            });

            if (response.data.status == "OK") {
                selectedItems.value = [...selectedItems.value, item]
            }

            // Update filteredItems with the API response
        } catch (error) {
            console.error("Error deleting Obj:", error);
        } finally {
            fetchOwnShop();
        }

        filteredItems.value = filteredItems.value.filter(i => i.id !== itemId);
        // Add it to the selected list

        // selectedItems.value.push(item);

        // Remove it from the autocomplete list

    } else if (item && itemAlreadySelected) {
        highlightItem(item)
    }

    // Clear the autocomplete selection
    menu.value = false;
};

const removeBrand = async (itemId) => {
    const hardToken = localStorage.getItem("hardToken");
    const username = localStorage.getItem("username");
    const softToken = localStorage.getItem("softToken");
    try {
        const response = await proxy.$axios.delete(`/shop/brand/${itemId}`, {
            headers: {
                'X-Auth-HARDTOKEN': hardToken,
                'X-Auth-SOFTTOKEN': softToken,
                'X-Auth-USER': username
            },
        });

        if (response.data.status == "OK") {
            selectedItems.value = selectedItems.value.filter(item => item.id !== itemId)
        }

        // Update filteredItems with the API response
    } catch (error) {
        console.error("Error deleting Obj:", error);
    } finally {
        fetchOwnShop();
    }
}

const emit = defineEmits(['update:modelValue'])

const highlightItem = (item) => {
    console.log(event);
}

const show = computed({
    get() {
        return props.modelValue;
    },
    set(value) {
        emit("update:modelValue", value);
    },
});

const closeSheet = () => {
    show.value = false;
}



</script>
<style>
.v-field--appended {
    padding-inline-end: 0px !important;
}
</style>

<style scoped>
@media only screen and (max-width: 960px) {
    .list-column {
        min-height: 200px;
        max-height: 250px;
        overflow-y: scroll;
    }
}

@media only screen and (min-width: 960px) {
    .list-column {
        min-height: 300px;
        max-height: 400px;
        overflow-y: scroll;
    }
}
</style>
